import React from "react";
import { Link } from "react-router-dom";
import MenuNavbar from '../../function-components/MenuNavbar';
import Floaticons from '../../function-components/Floaticons';
import "./Specializations.css";

function Specializations() {
    return (
        <><div className="banner-container">
            <img src="images/Banner1.png" alt="banner" className="banner-img" />
            <MenuNavbar />
        </div>
            <Floaticons />
            <div className="specialization-main-container specialization">
                <div className="SSA-container">
                    <div className="SSA-wrap">
                        <h2>Security Specialization Academy</h2>
                        <div className="SSA-row">
                            <div className="SSA-box">
                                <Link to={'/securitySchools#I&DInitiatives'} className="calendar-link">
                                    <img src="./images/SLF/New/Security-Schools.png" alt="SSA-img" className="SSA-img" />
                                    <div className="SSA-box-content">
                                        <h3>Security Schools and Bootcamps​</h3>
                                        <p>We cater to the critical learning needs of projects by creating a learning environment that includes customizing virtual cloud labs, creating reusable content on the LMS and on-ground support for the smooth conduct of the program​.</p>
                                        <a href="/securitySchools#I&DInitiatives" target="_blank">Security Schools and Bootcamps</a>
                                    </div>
                                </Link>
                            </div>
                            <div className="SSA-box">
                                {/* <Link to={'/securityTrainingCalendar'} className="calendar-link"></Link> */}
                                <img src="./images/SLF/New/SecurityTrainingCalendar.png" alt="SSA-img" className="SSA-img" />
                                <div className="SSA-box-content">
                                    <h3>Security Instructor-Led Learnings</h3>
                                    <p>The Security Training calendar is an outcome of the training needs identified during the <strong>Project Training Need Identification</strong> process. PTNI is an essential step to understanding the BU team’s training requirements and further catering to them accordingly.</p>
                                    <p className="comingSoonBottom">Coming Soon</p>
                                    {/* <a href="/securityTrainingCalendar" target="_blank">Security Training Calendar (accenture.com)</a> */}
                                </div>
                            </div>
                            <div className="SSA-box">
                                {/* <a href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home" target='_blank'> */}
                                <img src="./images/SLF/New/Security-Learning-Paths.png" alt="SSA-img" className="SSA-img" />
                                <div className="SSA-box-content">
                                    <h3>Security Progressive Learning Paths</h3>
                                    <p>Security Progressive Learning Path includes self-paced learning aligned to each Security Practice area. The learning paths are further categorized into career levels, skills, and specializations under each of the security practices.</p>
                                    <p className="comingSoonBottom">Coming Soon</p>
                                    {/* <a href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Wizard" target="_blank">Security Academy</a> */}
                                </div>
                                {/* </a> */}
                            </div>
                            <div className="SSA-box">
                                {/* <a href="https://in.accenture.com/technologyecosystemventures/partners/" target='_blank'> */}
                                <img src="./images/SLF/New/EcosystemPartnerLearnings.png" alt="SSA-img" className="SSA-img" />
                                <div className="SSA-box-content">
                                    <h3>Eco System Partners</h3>
                                    <p><strong>An Ecosystem Partner</strong> is a company Accenture officially creates a strategic alliance with including financial arrangements to better serve our clients along with negotiated training benefits.​</p>
                                    <a href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Ecosystem" target="_blank">Eco System Partners</a>
                                </div>
                                {/* </a> */}
                            </div>
                            <div className="SSA-box">
                                {/* <a href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home" target='_blank'> */}
                                <img src="./images/SLF/New/Cyberbit-2.0.png" alt="SSA-img" className="SSA-img" />
                                <div className="SSA-box-content">
                                    <h3>SOC Academy​</h3>
                                    <p>The SOC Academy Platform provides a full-scale cyber range, delivering a hyper-realistic, virtual SOC experience, that includes massive networks, reverse engineered attacks, and commercially licensed security tools.</p>
                                    <a href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home" target="_blank">SOC Academy</a>
                                </div>
                                {/* </a> */}
                            </div>
                            <div className="SSA-box">
                                {/* <a href="https://ts.accenture.com/sites/IS-Learning/Security/Pages/default.aspx" target='_blank'> */}
                                <img src="./images/SLF/New/Certification.png" alt="SSA-img" className="SSA-img" />
                                <div className="SSA-box-content">
                                    <h3>Certification</h3>
                                    <p>Aspiring to  getting a certification is a critical part of professional development. We present you a variety of self paced prep courses to help you in your certification journey.</p>
                                    <a href="https://ts.accenture.com/sites/SecurityLearningGuidanceWizard/SecurityAcademy/SiteAssets/index.aspx#Certifications" target="_blank">Security Academy (accenture.com)</a>
                                </div>
                                {/* </a> */}
                            </div>

                            <div className="SSA-box">
                                <img src="./images/SLF/New/LearningLabs.png" alt="SSA-img" className="SSA-img" />
                                <div className="SSA-box-content">
                                    <h3>Learning Labs</h3>
                                    <p>Learning Labs focuses on experiential learning with cloud labs by creating a virtual, scalable simulated environment for hands-on learning, practicing real-time scenarios, and acquiring the skills required by the projects.</p>
                                    <p className="comingSoonBottom">Coming Soon</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* <div className="SSA-wrap">
                        <div className="SSA-row">
                            
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    );
}

export default Specializations;